import { InputAdornment } from "@mui/material";
import _ from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import images from "../../assets/images";
import GlobalContext from "../../framework/GlobalContext";
import Image from "../../framework/Image";
import Shortcut from "../../framework/Shortcut";
import TextInput from "../../framework/TextInput";
import SkeletonGrid from "../../framework/skeleton/SkeletonGrid";
// import { searchBatch } from "../../services/batch-services";
import { searchGlobalMedicine } from "../../services/medicine-services";
import classes from "./ProductAutocomplete.module.css";
//import AddBatch from "../../sales/addBatch/AddBatch";
import { forwardRef } from "react";
import ProductSearchGrid from "./ProductSearchGrid";
import SearchBatchesGrid from "./SearchBatchesGrid";

const ProductAutocomplete = forwardRef((props, ref) => {
  const {
    searchTerm,
    medicineSelected = () => {},
    onEscape = () => {},
    showCurrentStock = true,
    isStockAudit = false,
  } = props;
  const { focusField } = useContext(GlobalContext);
  const { searchIcon, emptyMedicine, noMedicine } = images;
  const batchRef = useRef(null);
  const medicineSearchTableRef = useRef(null);
  const [medicine, setMedicine] = useState(null);
  const [medicineRowData, setMedicineRowData] = useState(null);
  const [batchRowData, setBatchRowData] = useState(null);
  const [substituteBatchRowData, setSubstituteBatchRowData] = useState(null);

  const [showBatchSearch, setShowBatchSearch] = useState(false);
  const [showAddBatch, setShowAddBatch] = useState(false);
  const [batchFilter, setBatchFilter] = useState("");

  const medicineSelectedHandler = (medicine, batch = {}) => {
    if (!medicine) {
      return;
    }
    medicineSelected({
      ...medicine,
      // batch: batch, // batch can be an object or array of selected batch object (parshva)
      // batches: batchRowData,
    });
  };
  const fetchMedicines = useCallback(
    (searchTerm) => {
      setShowBatchSearch(false);
      setShowAddBatch(false);
      setMedicine(null);
      return searchGlobalMedicine(`search=${searchTerm.trim()}`).then(
        (response) => {
          if (response?.status === "success") {
            if (response?.result?.length === 0) {
              setBatchRowData([]);
            }
            setMedicineRowData(response?.result);
            focusField("grid_medicine_search");
          }
        }
      );
    },
    [focusField]
  );
  // const fetchBatches = (medicineid) => {
  //   return searchBatch(
  //     `id=${medicineid}
  //   `,
  //     {
  //       headers: {
  //         cancelPrev: true,
  //       },
  //     }
  //   );
  // };
  // const fetchBatchesAndSubstitutes = (medicine) => {
  //   // setMedicine(medicine);
  //   fetchBatches(medicine.medicineId).then((batches) => {
  //     setBatchRowData(batches);
  //   });
  // };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  // const debounceFetchBatchesAndSubstitutes = useCallback(
  //   _.debounce(fetchBatchesAndSubstitutes, 300),
  //   []
  // );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceFetchMedicines = useCallback(
    _.debounce(fetchMedicines, 300),
    []
  );
  const listener = useCallback(
    (event) => {
      const key = event.key?.toLowerCase();
      if (key === "escape") {
        onEscape();
      }
    },
    [onEscape]
  );
  useEffect(() => {
    if (!medicineRowData?.length && !substituteBatchRowData) {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [listener, medicineRowData, substituteBatchRowData]);
  // useEffect(() => {
  //   return () => {
  //     debounceFetchBatchesAndSubstitutes.cancel();
  //   };
  // }, [debounceFetchBatchesAndSubstitutes]);

  useEffect(() => {
    if (searchTerm) {
      setMedicineRowData(null);
      setBatchRowData(null);
      setSubstituteBatchRowData(null);
      debounceFetchMedicines(searchTerm);
    }
    return () => {
      debounceFetchMedicines?.cancel();
      setMedicineRowData(null);
      setBatchRowData(null);
      setSubstituteBatchRowData(null);
    };
  }, [searchTerm, debounceFetchMedicines]);
  useEffect(() => {
    if (showBatchSearch || showAddBatch) {
      ref.current.api.stopEditing();
    }
  }, [ref, showAddBatch, showBatchSearch]);

  return (
    <div className={classes["medicine-ac-container"]}>
      {medicineRowData && medicineRowData?.length === 0 ? (
        <div className={classes["no-medicine-found-details"]}>
          <img src={noMedicine} alt="no-medicine-found" />
          <div className={classes["no-medicine-found-text"]}>
            Sorry we couldn't find
            <span style={{ color: "red", marginLeft: 5 }}>{searchTerm}</span>
          </div>
          <div className={classes["no-medicine-found-details-text"]}>
            Try searching something else with correct Spelling
          </div>
        </div>
      ) : (
        <>
          <div
            className={`${
              showBatchSearch && !showAddBatch
                ? "minimized-1 " + classes["minimized-1"]
                : showBatchSearch
                ? "minimized-2 " + classes["minimized-2"]
                : classes["medicine-container"]
            }`}
            style={isStockAudit && { width: "100%" }}
          >
            <div className={classes["medicine-shortcut-container"]}>
              <Shortcut keys={["Enter"]} label="Quick Add"></Shortcut>
              {/* <Shortcut keys={["Ctrl", "B"]} label="Add Batch"></Shortcut> */}
            </div>
            <div className={classes["medicine-search-container"]}>
              {!medicineRowData && <SkeletonGrid />}
              {medicineRowData?.length > 0 && (
                <ProductSearchGrid
                  ref={medicineSearchTableRef}
                  rowData={medicineRowData}
                  searchTerm={searchTerm}
                  batchRowData={batchRowData}
                  showCurrentStock={showCurrentStock}
                  selectionChanged={(params) => {
                    setBatchRowData(null);
                    setMedicine(params.api.getSelectedNodes()[0].data);
                    // if (showBatches)
                    // debounceFetchBatchesAndSubstitutes(
                    //   params.api.getSelectedNodes()[0].data
                    // );
                  }}
                  medicineSelected={() => {
                    // if (!batchRowData?.length && showBatches) return;
                    medicineSelectedHandler(
                      medicine
                      // showBatches && batchRowData[0]
                    );
                  }}
                  showBatchSearch={(value) => {
                    if (!batchRowData?.length) return;
                    setShowBatchSearch(value);
                    batchRef.current.focus();
                    focusField("grid_multi_batch_search");
                  }}
                  showAddBatch={setShowAddBatch}
                  onEscape={onEscape}
                />
              )}
            </div>
          </div>
          {/* {!showBatchSearch && !showAddBatch && showBatches && (
            <>
              <div className={classes["batch-subtitute-image-wrapper"]}>
                <BatchContainer
                  batchRowData={batchRowData}
                  product={medicine}
                  showCurrentStock={showCurrentStock}
                />
              </div>
            </>
          )} */}
          {/* {showAddBatch && !showBatchSearch && (
            <div className={classes["add-batch-container"]}>
              <AddBatch
                medicine={
                  medicineSearchTableRef.current.api.getSelectedNodes()[0].data
                }
                zeroQuantityForStock={true}
                onSave={(data) => {
                  onSave(data);
                  focusField("grid_medicine_search");
                  setShowAddBatch(false);
                  ref.current.focus();
                }}
                onEscape={() => {
                  focusField("grid_medicine_search");
                  setShowAddBatch(false);
                  ref.current.focus();
                }}
              />
            </div>
          )} */}
          {showBatchSearch && (
            <div className={classes["batch-container-image-wrapper"]}>
              <div
                className={`${
                  showAddBatch
                    ? "minimized-1 " + classes["minimized-1"]
                    : classes["batch-container"]
                }`}
              >
                <div className={classes["batch-input-shortcut-container"]}>
                  <div className={classes["batch-input"]}>
                    <TextInput
                      placeholder="Search Batch Here..."
                      value={batchFilter}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <img src={searchIcon} alt="search-batch" />
                          </InputAdornment>
                        ),
                      }}
                      size="small"
                      ref={batchRef}
                      onChange={(e) => setBatchFilter(e.target.value)}
                    />
                  </div>
                  <div className={classes["batch-shortcut-container"]}>
                    <div style={{ display: "flex" }}>
                      <Shortcut keys={["Ctrl", "↑"]} />/
                      <Shortcut keys={["Ctrl", "↓"]} label="Selection" />
                    </div>
                    <Shortcut keys={["Ctrl", "B"]} label="Add Batch"></Shortcut>
                    <Shortcut keys={["Enter"]} label="Quick Add"></Shortcut>
                    <Shortcut keys={["Esc"]} label="Go Back"></Shortcut>
                  </div>
                </div>

                <div className={classes["batch-search-container"]}>
                  <SearchBatchesGrid
                    rowData={batchRowData}
                    onEscape={() => {
                      setShowBatchSearch(false);
                      focusField("grid_medicine_search");
                      ref.current.focus();
                    }}
                    quickFilterText={batchFilter}
                    onEnter={(batch) => {
                      medicineSelectedHandler(medicine, batch);
                    }}
                    addRow={() => setShowAddBatch(true)}
                    showAddBatch={setShowAddBatch}
                    showCurrentStock={showCurrentStock}
                  />
                </div>
              </div>
              {showAddBatch ? (
                <div className={classes["batch-search-add-batch-container"]}>
                  <div className={classes["sales-add-batch-header"]}>
                    <div
                      className={
                        classes["sales-add-batch-header-shortcut-container"]
                      }
                      //QA feedback
                    >
                      <Shortcut keys={["Esc"]} label="Go Back" />
                    </div>
                  </div>
                  {/* <div className={classes["sales-add-batch-form-container"]}>
                    <AddBatch
                      medicine={
                        medicineSearchTableRef.current.api.getSelectedNodes()[0]
                          .data
                      }
                      onEscape={() => {
                        focusField("grid_multi_batch_search");
                        setShowAddBatch(false);
                        batchRef.current.focus();
                      }}
                      onSave={(data) => {
                        setBatchRowData([
                          { ...data, checked: true },
                          ...batchRowData,
                        ]);
                        focusField("grid_multi_batch_search");
                        setShowAddBatch(false);
                        batchRef.current.focus();
                      }}
                      searchTerm={batchFilter}
                      zeroQuantityForStock={true}
                    />
                  </div> */}
                </div>
              ) : (
                <div className={classes["batch-image-container"]}>
                  <Image
                    src={emptyMedicine}
                    alt={"medicine-image"}
                    label={"NO IMAGE FOUND"}
                  />
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
});
export default ProductAutocomplete;
